import React, { Component } from 'react';
import PropTypes from 'prop-types';
import pluralize from 'pluralize';
import { Dropdown, MenuItem } from 'react-bootstrap';
import enhanceWithClickOutside from 'react-click-outside';
import MoneyDisplay from '../money-display';
import NumberDisplay from '../number-display';
import styles from './styles.css';
import DoubleSlider from '../double-slider';

class DropdownRange extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      bounds: props.bounds,
      showModal: false,
    };
    this.onSliderChange = this.onSliderChange.bind(this);
    this.handleToggle = this.handleToggle.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.onModalToggle = this.onModalToggle.bind(this);
    this.onSliderChange1 = this.onSliderChange1.bind(this);
  }

  onSliderChange(bounds) {
    if (bounds[0] !== this.state.bounds[0] || bounds[1] !== this.state.bounds[1]) {
      this.setState({ bounds });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.bounds[0] !== this.props.bounds[0] || nextProps.bounds[1] !== this.props.bounds[1]) {
      this.setState({ bounds: [...nextProps.bounds] });
    }
  }

  onSliderChange1(bounds) {
    if (bounds[0] !== this.state.bounds[0] || bounds[1] !== this.state.bounds[1]) {
      this.setState({ bounds }, () => {
        this.props.onSliderChange(this.state.bounds);
      });
    }
  }

  handleClickOutside() {
    if (!this.state.showModal) {
      if (this.state.bounds && (this.state.bounds[0] !== this.props.bounds?.[0] || this.state.bounds[1] !== this.props.bounds?.[1])) {
        this.props.onSliderChange(this.state.bounds);
      }
      this.setState({ open: false });
    }
  }

  handleToggle(open, e, s) {
    if (open) {
      this.setState({ open });
    } else if (this.state.open && s.source === 'rootClose') {
      this.handleClickOutside();
    }
  }

  onModalToggle(showModal) {
    this.setState({ showModal });
  }

  getLabel() {
    const {
      isMoney, values, bounds, modalProps,
    } = this.props;
    const { fieldSuffix } = modalProps;
    const minIndex = bounds[0];
    const maxIndex = bounds[bounds.length - 1];
    const isExtremeMin = minIndex === 0;
    const isExtremeMax = maxIndex === values.length - 1;
    const amountMin = values[minIndex];
    const amountMax = values[maxIndex];

    let displayStr = 'All values';
    const DisplayComp = isMoney ? MoneyDisplay : NumberDisplay;
    const precision = isMoney ? 1 : 0;
    const suffixMin = !isMoney ? <span>&nbsp;{pluralize(fieldSuffix, amountMin)}</span> : null;
    const suffixMax = !isMoney ? <span>&nbsp;{pluralize(fieldSuffix, amountMax)}</span> : null;

    if (isExtremeMin && !isExtremeMax) {
      displayStr = (<span>Up to <DisplayComp value={amountMax} abbreviated precision={precision} />{suffixMax}</span>);
    } else if (!isExtremeMin && isExtremeMax) {
      displayStr = (<span>Above <DisplayComp value={amountMin} abbreviated precision={precision} />{suffixMin}</span>);
    } else if (!isExtremeMin && !isExtremeMax) {
      displayStr = (
        <span>
          {amountMin !== amountMax && <span>from&nbsp;</span>}
          <DisplayComp value={amountMin} abbreviated precision={precision} />{suffixMin}
          {amountMin !== amountMax && <span>&nbsp;to&nbsp;</span>}
          {amountMin !== amountMax && <span><DisplayComp value={amountMax} abbreviated precision={precision} />{suffixMax}</span>}
        </span>
      );
    }

    return displayStr;
  }

  render1() {
    const { disabled, isMoney, values } = this.props;
    const { open, bounds } = this.state;
    return (
      <Dropdown
        disabled={disabled}
        id="dropdown-ranges"
        onToggle={this.handleToggle}
        open={open}
      >
        <Dropdown.Toggle disabled={disabled}>
          <span>{this.getLabel()}</span>
        </Dropdown.Toggle>
        <Dropdown.Menu className={styles.dropdown}>
          <MenuItem header>Custom Boundaries:</MenuItem>
          <li
            className={styles.wrapper}
          >
            <span>
              <DoubleSlider
                values={values}
                bounds={bounds}
                isMoney={isMoney}
                onSliderChange={this.onSliderChange}
                modalProps={this.props.modalProps}
                disabled={this.props.disabled}
                displayProps={this.props.displayProps}
                onModalToggle={this.onModalToggle}
              />
            </span>
          </li>
        </Dropdown.Menu>
      </Dropdown>
    );
  }


  render() {
    const { disabled, isMoney, values, bsStyle } = this.props;
    const { open, bounds } = this.state;
    return (
      <DoubleSlider
        values={values}
        bounds={bounds}
        isMoney={isMoney}
        onSliderChange={this.onSliderChange1}
        modalProps={this.props.modalProps}
        disabled={disabled}
        displayProps={this.props.displayProps}
        onModalToggle={this.onModalToggle}
        bsStyle={bsStyle}
      />
    );
  }
  
}


DropdownRange.propTypes = {
  onSliderChange: PropTypes.func,
  bounds: PropTypes.arrayOf(PropTypes.number), // selected values: [lower, upper]
  values: PropTypes.arrayOf(PropTypes.number), // all possible values
  disabled: PropTypes.bool,
  isMoney: PropTypes.bool,
  displayProps: PropTypes.shape({}),
  modalProps: PropTypes.shape({}),
  bsStyle: PropTypes.string,
};
DropdownRange.defaultProps = {
  onSliderChange: () => {},
  displayProps: {},
  modalProps: {},
  bounds: [],
  values: null,
  isMoney: true,
  disabled: false,
  bsStyle: null,
};

export default enhanceWithClickOutside(DropdownRange);
